import watchGetFaqDataRequested from './getFaqDataSaga';

export default [
  watchGetFaqDataRequested(),
];
